import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import {GET_CONTACTS, GET_PROJECTS, BROADCAST_NOTIFICATION, BROADCAST_NOTIFICATION_USER_LIST} from "./type";

export const getContactsList = (requestParams) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.valet.getContacts}?limit=5000`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: GET_CONTACTS,
                payload: data.response.data,
            });
            return data.response.data;
        }
    }
    catch {
        dispatch({
            type: GET_CONTACTS,
            payload: null,
        });
        return null;
    }
}

export const getProjectsList = (requestParams) => async (dispatch) => {
    // console.log(data);
    dispatch({
        type: GET_PROJECTS,
        payload: null,
    });
    const res = await callWebService(
          callTypes.get,
          '',
          `${Config.valet.getProjects}?limit=5000`
        );
        // console.log(res); return false;
        if (res) {
          const { data } = res;
          dispatch({ type: GET_PROJECTS, payload: data.response.data });
          return data.response.data;
        }
}

export const sendNotification = (data) => async (dispatch) => {
    // console.log(data);
    dispatch({
        type: BROADCAST_NOTIFICATION,
        payload: null,
    });
    const res = await callWebService(
          callTypes.post,
          data,
          Config.valet.broadcastNotification
        );
        
        if (res) {
          const { data } = res;
          dispatch({ type: BROADCAST_NOTIFICATION, payload: data.response.status });
          return data.response.status;
        }
}

export const getNotificationUser = (data) => async (dispatch) => {
    // console.log(data);
    dispatch({
        type: BROADCAST_NOTIFICATION_USER_LIST,
        payload: null,
    });
    const res = await callWebService(
        callTypes.post,
        data,
        Config.valet.userNotificationList
    );

    if (res) {
        const { data } = res;
        dispatch({ type: BROADCAST_NOTIFICATION_USER_LIST, payload: data.response.data });
        return data.response.status;
    }
}

